module.exports = __webpack_public_path__ + "img/angle_120.f097f125.jpg";